import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchUsers, fetchUserAlerts, fetchPasswordPolicy, setUserStatus, createUser } from '../../services/api/identityService';

export const loadIdentity = createAsyncThunk('identity/load', async () => {
  const [users, alerts, policy] = await Promise.all([fetchUsers(), fetchUserAlerts(), fetchPasswordPolicy()]);
  return { users, alerts, policy };
});

export const changeUserStatus = createAsyncThunk('identity/changeUserStatus', async ({ id, status }) => setUserStatus(id, status));
export const createIdentityUser = createAsyncThunk('identity/createUser', async (payload) => createUser(payload));

const identitySlice = createSlice({
  name: 'identity',
  initialState: { status: 'idle', error: null, users: [], alerts: [], policy: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadIdentity.pending, (state) => { state.status = 'loading'; })
      .addCase(loadIdentity.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.users = action.payload.users;
        state.alerts = action.payload.alerts;
        state.policy = action.payload.policy;
      })
      .addCase(loadIdentity.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(createIdentityUser.fulfilled, (state, action) => { state.users.unshift(action.payload); })
      .addCase(createIdentityUser.rejected, (state, action) => { state.error = action.error.message; })
      .addCase(changeUserStatus.fulfilled, (state, action) => {
        const user = state.users.find((u) => u.id === action.payload.id);
        if (user) user.status = action.payload.status;
      });
  }
});

export default identitySlice.reducer;
